module.exports = __webpack_public_path__ + "img/excel.c59164de.svg";